import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "The safety of Brick Club members is of paramount importance. Please confirm the following prerequisites for the course ", -1)
const _hoisted_4 = { class: "flex items-center mt-2 space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "inline-block pl-[0.15rem]",
  for: "checkboxDefault"
}, " When running Brick Clubs I agree to deliver them in a professional capacity in an established organisation.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-700" }, " An 'established organisation' is an organisation that has it’s own safeguarding, risk management and complaints policies and procedures (e.g. a school, health centre, charity). ", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Please tick to confirm the following statements are true for the organisation(s):")
], -1)
const _hoisted_9 = { class: "flex items-center mt-2 space-x-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "inline-block pl-[0.15rem]",
  for: "checkboxDefault"
}, " The organisation has a safeguarding policy, risk management and complaints procedures.", -1)
const _hoisted_11 = { class: "flex items-center mt-2 space-x-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "inline-block pl-[0.15rem]",
  for: "checkboxDefault"
}, " Brick Clubs will be run in accordance with the safeguarding policy in the organisation", -1)
const _hoisted_13 = { class: "flex items-center space-x-2" }
const _hoisted_14 = {
  key: 0,
  class: "inline-block pl-[0.15rem]",
  for: "checkboxDefault"
}
const _hoisted_15 = {
  key: 1,
  class: "inline-block pl-[0.15rem]",
  for: "checkboxDefault"
}
const _hoisted_16 = { class: "mt-4 ml-4 list-disc" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Type your full name in the box below, this acts as your digital signature.", -1)

import { ref } from "vue";
import { useRoute } from "vue-router";

import TitleHeader from "@/components/TitleHeader.vue";
import DefaultButton from "@/components/DefaultButton.vue";

import api from "@/api/api";
import { useGlobalStore } from "@/store";
import { Booking } from "@/types";
import router from "@/router";
import ExternalLink from "@/components/ExternalLink.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AcceptTerms',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();

const booking = ref({} as Booking);
booking.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.bookings.getBooking(route.params.id))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.booking;

async function updateBooking() {
  try {
    (
      await api.bookings.updateBookingPrerequisites(booking.value.id, {
        signature: booking.value.signature,
        accepted_terms_conditions: booking.value.accepted_terms_conditions,
        qualified_professional: booking.value.qualified_professional,
        recognised_organisation: booking.value.recognised_organisation,
        has_safeguarding_policy: booking.value.has_safeguarding_policy,
        will_adhere_safeguarding_policy: booking.value.will_adhere_safeguarding_policy,
      })
    ).data.booking;

    globalStore.toast("SUCCESS", "Booking updated");
    return router.push({ name: "Courses" });
  } catch (e) {
    console.log(e);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('course-prerequisites')
    }, null, 8, ["title"]),
    _createElementVNode("form", {
      class: "mt-8 space-y-8",
      onSubmit: _withModifiers(updateBooking, ["prevent"])
    }, [
      (booking.value.event!.level === 'Certified Facilitator')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((booking.value.recognised_organisation) = $event)),
                class: "rounded hover:cursor-pointer",
                required: ""
              }, null, 512), [
                [_vModelCheckbox, booking.value.recognised_organisation]
              ]),
              _hoisted_5
            ]),
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      (booking.value.event!.level === 'Certified Facilitator')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((booking.value.has_safeguarding_policy) = $event)),
                class: "rounded hover:cursor-pointer",
                required: ""
              }, null, 512), [
                [_vModelCheckbox, booking.value.has_safeguarding_policy]
              ]),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((booking.value.will_adhere_safeguarding_policy) = $event)),
                class: "rounded hover:cursor-pointer",
                required: ""
              }, null, 512), [
                [_vModelCheckbox, booking.value.will_adhere_safeguarding_policy]
              ]),
              _hoisted_12
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((booking.value.accepted_terms_conditions) = $event)),
          class: "rounded hover:cursor-pointer",
          required: ""
        }, null, 512), [
          [_vModelCheckbox, booking.value.accepted_terms_conditions]
        ]),
        (booking.value.event!.level === 'Certified Facilitator')
          ? (_openBlock(), _createElementBlock("label", _hoisted_14, " I confirm that I have read and accept the following terms and policies: "))
          : _createCommentVNode("", true),
        (booking.value.event!.level === 'Advanced Facilitator')
          ? (_openBlock(), _createElementBlock("label", _hoisted_15, " I confirm that I continue to meet the professional requirements and the details in my Play Included account are up to date. I agree to abide by the following terms and policies: "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_16, [
          _createElementVNode("li", null, [
            _createVNode(ExternalLink, {
              href: "https://playincluded.com/en-gb/terms-and-conditions",
              label: "Booking Terms and Conditions",
              type: "text"
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(ExternalLink, {
              href: "https://playincluded.com/safeguarding-policy",
              label: "Play Included Safeguarding Policy",
              type: "text"
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(ExternalLink, {
              href: "https://playincluded.com/code-of-conduct",
              label: "Play Included Code of Conduct",
              type: "text"
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(ExternalLink, {
              href: "https://playincluded.com/privacy-cookie-policy",
              label: "Privacy Policy",
              type: "text"
            })
          ])
        ])
      ]),
      _hoisted_17,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((booking.value.signature) = $event)),
        class: "block w-full h-10 px-4 py-2 text-gray-900 border border-gray-600 rounded-l",
        placeholder: "John Smith",
        required: ""
      }, null, 512), [
        [_vModelText, booking.value.signature]
      ]),
      _createVNode(DefaultButton, {
        type: "primary",
        class: "my-8 whitespace-nowrap",
        "is-form-submit": true
      }, {
        default: _withCtx(() => [
          _createTextVNode("Confirm prerequisites")
        ]),
        _: 1
      })
    ], 40, _hoisted_1)
  ]))
}
}

})